// extracted by mini-css-extract-plugin
export default {"select":"style_select__4awcW"};